/**
 * @file
 * Slider.
 */

'use strict';

import Vue from 'vue';
import axios from 'axios';

const TIMEOUT = 5000;
const THRESHOLD = 50;

Vue.component('alphabet-search', require('../components/AlphabetSearch.vue').default);

Vue.component('slider', {
  template: `
    <div class="slider" :class="'slider--' + page">
      <div class="slider-arrow slider-arrow--left" @click="moveSlider(-1)" v-if="page === 'front'">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" xml:space="preserve">
          <polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153" style="transform: rotate(180deg)"/>
        </svg>
      </div>
      <div class="slider-overlay" @mouseover="sliderOver" @mouseleave="sliderLeave">
        <div class="slider-progress slider-progress--top" v-if="page === 'front' && rendered && ww && ww < 641">
          <div class="slider-progress-body" :class="resetProgress ? 'slider-progress-body--reset' : ''" :style="'width: ' + progress + '%'"></div>
        </div>
        <template v-if="rendered">
          <div
          v-for="slide, index in slides"
          class="slide slide--gifts"
          :class="[{'slide--choosen': choosen == index}, 'slide--gifts-gradient-' + slide.slideGradient]"
          :style="'background-image: url(' + slide.image + ')'">
            <a :href="slide.link" class="slide-link" v-if="slide.isImageBanner && slide.link"></a>
            <div class="slide-inner" v-else>
              <div class="slide-title">
                <div class="colored">
                  {{ slide.title }}
                </div>
                <div class="slide-subtitle">
                  {{ slide.subtitle }}
                </div>
              </div>
              <div class="slide-footer">
                <div class="slide-button">
                  <a :href="slide.link" class="btn-main btn-big">
                    <span class="btn-main-overlay">
                      <span class="btn-main-content">
                        {{ slide.slideButtonLabel }}
                      </span>
                    </span>
                    <span class="btn-main-shadow"></span>
                  </a>
                </div>
                <div class="slide-mark" v-if="slide.rules">
                  {{ slide.rules }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="slide slide--skeleton">
            <div class="slide-inner slide--skeleton-inner">
              <div class="slide-title slide--skeleton-title">
                <div class="slide--skeleton-content">
                </div>
              </div>
              <div class="slide-footer">
                <div class="slide-button slide--skeleton-button">
                  <div class="slide--skeleton-content">
                  </div>
                </div>
                <div class="slide-mark slide--skeleton-mark">
                  <div class="slide--skeleton-content">
                  </div>
                </div>
              </div>
            </div>
          </div>      
        </template>
        <div class="slider-progress slider-progress--bottom" v-if="page === 'front' && rendered">
          <div class="slider-progress-body" :class="resetProgress ? 'slider-progress-body--reset' : ''" :style="'width: ' + progress + '%'"></div>
        </div>
      </div>
      <div class="slider-arrow slider-arrow--right" @click="moveSlider(1)" v-if="page === 'front'">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" xml:space="preserve">
          <polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153"/>
        </svg>
      </div>
    </div>
  `,
  props: {
    page: {
      type: String,
      default: 'front'
    }
  },
  data() {
    return {
      ww: 0,
      choosen: 0,
      lastTime: 0,
      timer: false,
      timeLeft: true,
      rendered: false,
      resetProgress: false,
      interval: '',
      timerInterval: '',
      slides: []
    }
  },
  methods: {
    loadSlides() {
      axios.get('/slider/get-slides').then((response) => {
        this.slides = response.data || []
        this.rendered = true
        this.autoPlay()
      })
    },
    autoPlay() {
      this.sliderOver();
      this.interval = setInterval(() => {
        if (this.lastTime >= TIMEOUT) {
          this.lastTime = 0;
          this.moveSlider(1);
          this.resetProgress = true;
          setTimeout(() => {
            this.resetProgress = false;
          }, 10);
        }
        this.lastTime += 100;
      }, 100);
    },
    sliderOver() {
      clearInterval(this.interval);
    },
    sliderLeave() {
      this.autoPlay();
    },
    moveSlider(direction) {
      let index = this.choosen + direction;
      if (index < 0) {
        index = this.slides.length - 1;
      }
      else if (index >= this.slides.length) {
        index = 0;
      }
      this.choosen = index;
      this.lastTime = 0;
      this.autoPlay();
    },
    swipeNav() {
      let touchend = 0;
      let touchstart = 0;
      const ELEMENT = document.getElementById('block-slider');

      ELEMENT.addEventListener('touchstart', (event) => {
        touchstart = event.changedTouches[0].screenX;
        if (!touchend) {
          touchend = touchstart;
        }
        if (touchend - THRESHOLD > touchstart || touchend + THRESHOLD < touchstart) {
          event.preventDefault();
        }
      }, { passive: true });

      ELEMENT.addEventListener('touchend', (event) => {
        touchend = event.changedTouches[0].screenX;
        this.handleSwipe(touchend, touchstart, event);
        touchend = 0;
      }, { passive: true });
    },
    handleSwipe(touchend, touchstart) {
      if (touchend - THRESHOLD > touchstart) {
        this.moveSlider(-1);
      }
      else if (touchend + THRESHOLD < touchstart) {
        this.moveSlider(1);
      }
    },
    socialGoals(social) {
      if (typeof yaCounter23358985 == 'object') {
        yaCounter23358985.reachGoal(`slide_social_${social}`);
      }
    },
    reachGoal(goal) {
      if (typeof yaCounter23358985 === 'object') {
        yaCounter23358985.reachGoal(goal);
      }
    },
  },
  created() {
    this.loadSlides()
  },
  mounted() {
    this.ww = window.innerWidth;
    this.swipeNav();
    window.onload = () => {
      this.ww = window.innerWidth;
    };
  },
  computed: {
    progress() {
      return parseInt((this.lastTime / TIMEOUT) * 100) + 5;
    },
  },
});

Vue.component('payment-thanks-modal', {
  template: `
    <div class="modal fade pr-modal cg-modal" id="bank-modal">
      <div class="modal-dialog cg-modal-dialog">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
        <div class="nauth modal-content">
          <div class="modal-body pr-form">
            <div class="modal-title pr-modal-title pr-modal-title--ob">
              Благодарим за оплату
            </div>
            <div class="pr-modal-text">
              <p>
                Подтверждение оплаты занимает в среднем 10-15 минут
              </p>
              <p>
                Если по истечению этого срока у вас не изменился статус заказа, пожалуйста, напишите нам на почту <a href="mailto:zakaz@garshinka.ru" class="pr-modal-text-link">zakaz@garshinka.ru</a>
              </p>
            </div>
            <div class="pr-modal-button">
              <button type="button" class="btn--green" data-dismiss="modal">
                Хорошо
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  mounted() {
    if (window.$cookies.get('paymentCompleted') === 'true') {
      jQuery(this.$el).modal('show');
      window.$cookies.set('paymentCompleted', null, 0, '/');
    }
  },
});

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    delimiters: ['${', '}'],
    el: '#block-slider',
    methods: {
      declOfNum(number, titles) {
        const cases = [2, 0, 1, 1, 1, 2];
        return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
      },
      setRegisterCookie() {
        window.$cookies.set('promo-register', 'front-bonus-banner', '10MIN');
      },
    },
    mounted() {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('fbb') === 'fp' && drupalSettings.user.uid === 0) {
        this.setRegisterCookie();
        document.dispatchEvent(new Event('showRegisterPopup'));
      }
    },
  });
});
